var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Menu'),_c('router-view'),_c('Foot',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFoot),expression:"showFoot"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }